function dataSigaoToNormal(data) {
	if (data) {
		var dataJ = new Date(data);
		var anno = dataJ.getFullYear();
		var mese = dataJ.getMonth() + 1;
		var giorno = dataJ.getDate();
		if (mese < 10) {
			mese = "0" + mese;
		}
		if (giorno < 10) {
			giorno = "0" + giorno;
		}
		return anno + "-" + mese + "-" + giorno;
		//return dataJ.toISOString().substring(0, 10)
		//data.substring(6, 10) + "-" + data.substring(0, 2) + "-" + data.substring(3, 5)
	} else {
		return null;
	}
}

function timeSigaoToNormal(time) {
	if (time) {
		var dataJ = new Date(time);
		//extract time from the date for the time input
		var hours = dataJ.getHours();
		var minutes = dataJ.getMinutes();
		if (hours < 10) {
			hours = "0" + hours;
		}
		if (minutes < 10) {
			minutes = "0" + minutes;
		}
		return hours + ":" + minutes;
	} else {
		return null;
	}
}
function dataSigaoToIta(data) {
	if (data) {
		//var dataJ = new Date(data)

		//var newDateObj = dataJ.getTime() + dataJ.getTimezoneOffset()*60000;
		let datas = new Date(data); //new Date(newDateObj)
		var anno = datas.getYear() - 100 + 2000;
		var mese = datas.getMonth() + 1;
		var giorno = datas.getDate();
		if (mese < 10) {
			mese = "0" + mese;
		}
		if (giorno < 10) {
			giorno = "0" + giorno;
		}
		return giorno + "/" + mese + "/" + anno;
		//return dataJ.toISOString().substring(0, 10)
		//data.substring(6, 10) + "-" + data.substring(0, 2) + "-" + data.substring(3, 5)
	} else {
		return null;
	}
}

export { dataSigaoToIta, dataSigaoToNormal, timeSigaoToNormal };
